import { render } from "./Clientsreview.vue?vue&type=template&id=5657d6ff&scoped=true"
import script from "./Clientsreview.vue?vue&type=script&lang=js"
export * from "./Clientsreview.vue?vue&type=script&lang=js"

import "./Clientsreview.vue?vue&type=style&index=0&id=5657d6ff&scoped=true&lang=css"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5657d6ff"]])

export default __exports__